import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp } from 'lucide-react';
import { CompetitorsCTA } from './CompetitorsCTA';
import { StoryCTA } from './StoryCTA';
import { IdeaCTA } from './IdeaCTA';
import { ExpectationsCTA } from './ExpectationsCTA';
import { AgreementCTA } from './AgreementCTA';
import { useLanguage } from '../i18n/LanguageContext';
export function MarketContext() {
  const {
    t
  } = useLanguage();
  const cards = t('market.cards') as {
    title: string;
    desc: string;
  }[];
  return <section className="py-24 px-6 bg-zinc-950" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex items-center gap-3 mb-8" data-id="element-152">
          <div className="w-10 h-10 rounded-full bg-magenta-500/10 flex items-center justify-center" data-id="element-153">
            <TrendingUp className="w-5 h-5 text-magenta-500" data-id="element-154" />
          </div>
          <span className="text-sm uppercase tracking-widest text-zinc-500 font-medium" data-id="element-155">
            {t('market.opportunity')}
          </span>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="font-serif text-2xl md:text-4xl leading-snug text-zinc-200 mb-12" data-id="element-156">
          {t('market.p1Start')}
          <span className="text-magenta-500" data-id="element-157">{t('market.p1Highlight')}</span>
          {t('market.p1End')}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12" data-id="element-158">
          {cards.map((card, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6" data-id="element-159">
              <p className={`font-serif text-4xl mb-2 ${i === 0 ? 'text-cyan-300' : i === 1 ? 'text-magenta-500' : 'text-zinc-200'}`} data-id="element-160">
                {card.title}
              </p>
              <p className="text-sm text-zinc-500" data-id="element-161">{card.desc}</p>
            </div>)}
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.3
      }} className="text-lg text-zinc-400 font-light leading-relaxed" data-id="element-162">
          {t('market.p2Start')}
          <span className="text-zinc-200 font-medium" data-id="element-163">
            {t('market.p2Highlight')}
          </span>
          {t('market.p2End')}
        </motion.p>

        <CompetitorsCTA data-id="element-164" />
        <StoryCTA data-id="element-165" />
        <IdeaCTA data-id="element-166" />
        <ExpectationsCTA data-id="element-167" />
        <AgreementCTA data-id="element-168" />
      </div>
    </section>;
}